/* eslint-disable react-hooks/exhaustive-deps */
import {
  EditOutlined,
  ArrowUpOutlined,
  PlusOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import { Table, Button, message, Modal, Card } from "antd";
import { useTranslation } from "react-i18next";
import { animateScroll as scroll } from "react-scroll";
import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import "../../../shared/styles/GetProducts.css";
import "../../../shared/styles/ListPages.css";
import { formatCurrency } from "../../../utils/formatters";
import { apiClient, getStorageUrl } from "../../../shared/api/AllApi";
import { useProductsCatalog } from "../../../hooks/useCatalogData";
import { parseLocalizedName } from "../../../utils/localization";
import usePermissions from "../../../hooks/usePermissions";
import { filterBySearch } from "../../../shared/lib/listSearch";
import ListSearch from "../../../shared/ui/ListSearch";

const GetProducts = () => {
  const { hasPermission } = usePermissions();
  const [SearchText, setSearchText] = useState("");
  const [dataSource, setDataSource] = useState([]);
  const [deleteItemId, setDeleteItemId] = useState(null);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const { data: productsData, loading, refresh } = useProductsCatalog();

  const { t, i18n } = useTranslation();

  useEffect(() => {
    setDataSource(
      productsData.map((item) => {
          let nameObj = { en: "N/A", ar: "N/A" };
          let unitObj = { en: "N/A", ar: "N/A" };
          let image = item.image_url ? item.image_url : null;

          try {
            nameObj = item.name ? JSON.parse(item.name) : { en: "N/A" };
          } catch (error) {
            console.warn("Error parsing name:", error);
          }
          try {
            unitObj =
              item.unit.name && item.unit.name
                ? JSON.parse(item.unit.name)
                : { en: "N/A" };
          } catch (error) {
            console.warn("Error parsing unit:", error);
          }          // Extract sub unit name, ratio, and price and combine them
          let subUnitName = "-";
          let subUnitRatio = "-";
          let combinedSubUnitInfo = "-";
          let subUnitPrice = "-";

          if (item.sub_unit && item.sub_unit.name) {
            try {
              const subUnitObj = JSON.parse(item.sub_unit.name); subUnitName = subUnitObj[i18n.language] || subUnitObj.en || "-";
              subUnitRatio = item.sub_unit_ratio || "-";
              subUnitPrice = item.sub_unit_price ? formatCurrency(item.sub_unit_price) : "-";

              // Combine ratio and name in one field (ratio first, no parentheses)
              if (subUnitName !== "-" && subUnitRatio !== "-") {
                combinedSubUnitInfo = `${subUnitRatio} ${subUnitName}`;
              } else if (subUnitName !== "-") {
                combinedSubUnitInfo = subUnitName;
              }
            } catch (error) {
              console.warn("Error parsing sub unit name:", error);
            }
          } return {
            id: item.id,
            nameKurdish: parseLocalizedName(item.name, i18n.language, "N/A"),
            Unit: unitObj[i18n.language] || nameObj.en || "N/A",
            price: formatCurrency(item.price),
            sku: item.sku,
            stock: item.stock,
            combinedSubUnitInfo: combinedSubUnitInfo,
            image: image,
            subUnitPrice: subUnitPrice,            weight: item.weight ? item.weight : '-',
            total_weight: item.total_weight ? `${item.total_weight} Kg` : '-',            category: item.category ? (() => {
              try {
                const categoryObj = JSON.parse(item.category.name);
                // Use the current language, with fallback to English
                return categoryObj[i18n.language] || categoryObj.en || "-";
              } catch (error) {
                console.warn("Error parsing category name:", error);
                return "-";
              }
            })() : "-"
          };
        })
    );
  }, [productsData, i18n.language, t]);

  const handleDelete = (id) => {
    setDeleteItemId(id);
    setIsDeleteModalVisible(true);
  };
  const handleConfirmedDelete = async () => {
    try {
      await apiClient.delete(`/products/${deleteItemId}`);

      message.success(t("Product deleted successfully"));
      await refresh();
      setDeleteItemId(null);
      setIsDeleteModalVisible(false);
    } catch (error) {
      console.error("Error deleting product:", error);
      message.error(t("Error deleting product"));
    }
  };

  const columns = [
    {
      title: "id",
      key: "index",
      render: (text, record, index) => index + 1,
    },
    {
      title: t("image"),
      dataIndex: "image",
      key: "image",
      width: 70,
      render: (image) =>
        image ? (
          <img
            src={getStorageUrl(image)}
            alt="product"
            style={{ width: 44, height: 44, objectFit: "cover", borderRadius: 8 }}
          />
        ) : (
          <div
            style={{
              width: 44,
              height: 44,
              borderRadius: 8,
              background: "#f1f5f9",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#94a3b8",
              fontSize: 11,
            }}
          >
            N/A
          </div>
        ),
    },
    {
      title: t("name"),
      dataIndex: "nameKurdish",
      key: "nameKurdish",
      render: (text, record) => (
        <Link to={`/products/${record.id}/history`}>{text}</Link>
      ),
    },
    {
      title: t("price"),
      dataIndex: "price",
      key: "price",
    },
    {
      title: t("categories"),
      dataIndex: "category",
      key: "category",
    },
    {
      title: t("unit"),
      dataIndex: "Unit",
      key: "Unit",
    },
    {
      title: t("یەکەی ژێر"),
      dataIndex: "combinedSubUnitInfo",
      key: "combinedSubUnitInfo",
    },
    {
      title: t("نرخی یەک ژێر یەکە"),
      dataIndex: "subUnitPrice",
      key: "subUnitPrice",
    },
    {
      title: t("sku"),
      dataIndex: "sku",
      key: "sku",
    },
    {
      title: t("stock"),
      dataIndex: "stock",
      key: "stock",
    },
    {
      title: t("کێش"),
      dataIndex: "weight",
      key: "weight",
    },
    {
      title: t("کۆی گشتی کێش"),
      dataIndex: "total_weight",
      key: "total_weight",
    },
    {
      title: t("کۆی گشتی بابەت"),
      dataIndex: "totalValue",
      key: "totalValue",
      render: (text, record) => {
        // price is formatted, so parse it to number
        const priceNum = typeof record.price === 'string' ? Number(record.price.replace(/[^\d.-]/g, '')) : record.price;
        const total = priceNum * (parseFloat(record.stock) || 0);
        return formatCurrency(total);
      },
    },
    ...(hasPermission("products.delete") ? [{
      title: t("delete"),
      key: "deleteAction",
      render: (text, record) => (
        <Button type="primary" danger size="small" icon={<DeleteOutlined />} onClick={() => handleDelete(record.id)} />
      ),
    }] : []),
    ...(hasPermission("products.edit") ? [{
      title: t("edit"),
      key: "editAction",
      render: (text, record) => (
        <Link to={`/GetProducts/UpdateProducts/${record.id}`}>
          <Button type="primary" size="small" icon={<EditOutlined />} />
        </Link>
      ),
    }] : []),
  ];

  const filteredData = useMemo(
    () =>
      filterBySearch(dataSource, SearchText, (item) => [
        item.id,
        item.nameKurdish,
        item.sku,
        item.category,
        item.Unit,
        item.combinedSubUnitInfo,
        item.price,
        item.stock,
      ]),
    [dataSource, SearchText]
  );

  const totalPrice = filteredData.reduce(
    (total, item) => total + item.price * item.stock,
    0
  );

  // Calculate total value and total weight sums for the footer
  const totalValueSum = filteredData.reduce((sum, item) => {
    const priceNum = typeof item.price === 'string' ? Number(item.price.replace(/[^\d.-]/g, '')) : item.price;
    return sum + (priceNum * (parseFloat(item.stock) || 0));
  }, 0);
  // Correct total weight: sum of (weight * stock) for each product
  const totalWeightSum = filteredData.reduce((sum, item) => {
    const weight = parseFloat(item.weight);
    const stock = parseFloat(item.stock);
    if (!isNaN(weight) && !isNaN(stock)) {
      return sum + (weight * stock);
    }
    return sum;
  }, 0);

  const scrollToTop = () => {
    scroll.scrollToTop();
  };

  return (
    <div className="list-page">
      <Card title={t("productList")} variant="borderless">
        <div className="list-page-toolbar">
          <ListSearch
            value={SearchText}
            onChange={setSearchText}
            className="list-page-search"
            width={360}
          />
          {hasPermission("products.add") && (
            <Link to="/AddProducts">
              <Button type="primary" icon={<PlusOutlined />}>
                {t("addItem")}
              </Button>
            </Link>
          )}
        </div>
        <Button
          type="primary"
          className="scroll-to-top-button"
          onClick={scrollToTop}
        >
          <ArrowUpOutlined />
        </Button>
        <Table
          loading={loading}
          dataSource={filteredData.map((item) => ({ ...item, key: item.id }))}
          columns={columns}
          pagination={{ pageSize: 50 }}
          scroll={{ x: "max-content" }}
          summary={() => (
            <Table.Summary.Row className="table-summary-row">
              <Table.Summary.Cell colSpan={7} />
              <Table.Summary.Cell colSpan={1} className="summary-cell summary-cell--blue">
                {t("totalPrice")}: {formatCurrency(totalPrice)}
              </Table.Summary.Cell>
              <Table.Summary.Cell colSpan={2} className="summary-cell summary-cell--yellow">
                {t("totalValue")}: {formatCurrency(totalValueSum)}
              </Table.Summary.Cell>
              <Table.Summary.Cell colSpan={2} className="summary-cell summary-cell--teal">
                {t("کۆی گشتی کێش")}: {totalWeightSum.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 })} Kg
              </Table.Summary.Cell>
            </Table.Summary.Row>
          )}
        />
      </Card>

      <Modal
        style={{ direction: "rtl" }}
        title={t("confirmDelete")}
        open={isDeleteModalVisible}
        onOk={handleConfirmedDelete}
        onCancel={() => setIsDeleteModalVisible(false)}
        okText={t("confirm")}
        cancelText={t("cancel")}
      >
        <p>{t("confirmDeleteMessage")}</p>
      </Modal>
    </div>
  );
};

export default GetProducts;

